<template>
  <div class="auto-page" :key="currKey" :style="{width: width + 'px'}" v-if="data.length">
    <div class="page-row" v-for="(row, i) in data" :key="i">
      <div :class="'lh1 type-' + row.type" :style="{height: row.type === 2 ? row.height + 'px' : ''}" v-if="row.type < 3">{{row.content}}
      </div>
      <div v-else class="flex jcb" :class="'type-' + row.type">
        <course-card :image-width="row.width" :image-height="row.height" v-for="(col, j) in row.content_area" :key="j" :width="row.width" :style="{marginRight: spacing + 'px'}"
          :change-prop="changeProp" :show-props="showProps" :item="col" @detail="clickCallback" @play="playAudio" @pause="pauseAudio"></course-card>
      </div>
    </div>
  </div>
  <offline v-else :is-no-data="!data.length" show class="no-data"></offline>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: "AutoPage",
  computed: {
    ...mapGetters(['userInfo', 'currAudio','currTab','allTabsList','currGrade']),
    audio () {
      return this.currAudio ? this.GetAppAudio() : null;
    },
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 1196
    },
    showProps: {
      type: String | Array,
      default: 'name'
    },
    initPage: Function,
  },
  data () {
    return {
      data: [],
      currKey: 1,
      proportion: 1,
      spacing: 16,
      changeProp: {
        'element_content.buy_num': 'buy_num',
        'element_content.price': 'price',
        'element_content.vip_price': 'vip_price',
        'element_content.is_activity': 'is_activity',
        'element_content.is_pay': 'is_pay',
        'element_content.discount': 'discount',
        'element_content.original_price': 'original_price',
        'element_content.original_vip_price': 'original_vip_price',
      },
      audioLoading: false,
			curr:1,
			limits:10,
			tabAllData:[]
    };
  },
  watch: {
    code () {
      this.reSetPage();
    },
    audio (val) {
      if (!this.audioLoading && val) {
        this.audioLoading = true;
        val.$on('play', this.audioEvent);
        val.$on('pause', this.audioEvent);
      }
    },
		currTab(val){
		},
		allTabsList(val){
			//tab栏改变时重置页面请求
			this.initTabPageData();
		},
		currGrade(val){
			//年级改变时重置页面请求
			this.tabAllData = [];
			this.initTabPageData();
		}
  },
  created () {
		this.initTabPageData();
  },
  methods: {
    ...mapMutations(['setCurrAudio']),
		reSetPage(){
			let that= this;
			that.data = []
			this.curr = 1;
			this.getPage();
		},
    async getPage () {
			let that = this;
			let loadItem = this.tabAllData.find(item=>item.value===this.currTab)
			if(loadItem && loadItem.value===this.currTab && loadItem.data.length > 0){
				// 当前tab已经加载过就从 tabAllData 中拿
				await this.setPageData(loadItem.res);
				this.data = loadItem.data;
				return 
			}
      let { code: page_code, Product, userInfo } = this;
      try {
        
        let params = {
          page_code,
					curr:this.curr,
					limits:this.limits,
          uid: userInfo.uid,
          ...Product,
        };
        let res = await this.http.NEWAutoPage(params, { needCancel: 'url' });

				// 验证响应数据结构
				if (!res || !res.list || !Array.isArray(res.list)) {
					console.warn('[NEWAutoPage] 接口返回数据格式异常:', res);
					throw new Error('接口返回数据格式异常');
				}

				if(this.curr===1){
					that.data = []
					//清空data
				}
				await this.setPageData(res);
				// 图片资源先不展示，等待分页都调用完后再全部显示
				res.list.forEach(item=>{
					if(item.content_area){
						item.content_area.forEach(citem=>{
							citem['load_img'] = citem['cover_img1']
							citem['cover_img1'] = ''
						})
					}
				})
        that.data = that.data.concat(res.list);
				this.curr++
				if(this.curr <=  Math.ceil(res.total/this.limits)){
					// 当前页码没有大于 总条数/获取条数时,页码增加继续获取
					this.$nextTick(()=>{
						this.getPage()
					})
				}else{
					// 加载完当前tab数据，并插入到this.tabAllData对应的data中
					this.curr = 1;
					// 分页加载完成,替换底图为原本图片 目前原本图片字段为 cover_img1
					that.data.forEach(item=>{
						if(item.content_area){
							item.content_area.forEach(citem=>{
								let img = new Image();
								img.src = citem['load_img']
								// 等待图片资源加载完成再替换
								img.addEventListener('load', () => {
									// 图片替换为原本图片
									citem['cover_img1'] = citem['load_img']
									img = null
								});
							})
						}
					})
					this.tabAllData.forEach(item=>{
						if(item.value===this.currTab){
							item.data = that.data;
							item.res = {
								...item.res,
								...res
							}
						}
						
					})
					// console.log(this.tabAllData,'tabAllData')
				}
				
      } catch (e) {
        // 处理异常响应（如 {time: ...}）
        if (e && e.time) {
          console.warn('[NEWAutoPage] 接口返回异常格式，可能是 Session 过期或限流:', e);
        } else {
          this.$err(e);
        }
        throw e;
      }
    },
		async setPageData(res){
			let { width, margin, spacing } = res.config;
			this.currKey++;
			this.proportion = (width - margin * 2) / parseFloat(this.width + '');
			this.spacing = Math.min(16, spacing / this.proportion | 0);
			res.list.forEach(row => {
			  this.setSize(row);
			});
			this.initPage && await this.initPage(res);
			
		},
		async initTabPageData(){
			// 重置掉tab页的数据
			this.tabAllData = [];
			await this.reSetPage();
		  this.tabAllData = this.allTabsList.map(item=>{
				return {
					...item,
					data:[],
					res:{}
				}
			})
		},
    setSize (row) {
      switch (row.type) {
        case 1:
          row.height = {
            16: 20,
            24: 30,
            48: 50,
          }[row.height] || (row.height / this.proportion | 0);
          break;
        case 3:
          [row.width, row.height] = {
            1: {
              168: [1196, 173],
            },
            2: {
              168: [590, 173],
              274: [590, 282],
              340: [590, 352],
            },
            3: {
              172: [388, 177],
              220: [388, 232],
            },
            4: {
              164: [287, 171],
            },
            5: {
              248: [226, 259],
            },
            6: {
              168: [186, 204],
              204: [186, 213],
            },
            7: {
              172: [157, 180],
            },
          }[row.num][row.height] || [(this.width - this.spacing * (row.num - 1)) / row.num | 0, row.height / this.proportion];
          break;
      }
    },
    clickCallback (item) {
      this.$emit('click-callback', item);
    },
    // 音频播放
    async playAudio (item) {
      try {
        if (this.currAudio && this.currAudio.cid === item.element_content.id) {
          await this.pauseAudio();
          return;
        }
        let params = {
          course_id: item.element_content.id,
          uid: this.userInfo.uid,
          is_new: 1,
          channel_type: 2,
          ...this.Product,
        };
        let res = await this.http.getResourceList(params);
        this.setCurrAudio({ cid: item.element_content.id, rid: res.resource_list.data[0].id, type: item.element_content.type, isPlay: true });
      } catch (e) {
        this.ShowToast(e.msg || '网络错误！');
      }
    },
    pauseAudio (item) {
      if (this.audio) {
        this.audio.ctrlCb('play');
      }
    },
    audioEvent (audio) {
      this.setCurrAudio(Object.assign(this.currAudio, { isPlay: this.audio && this.audio.playing }));
    }
  }
}
</script>

<style scoped lang="less">
.auto-page {
  .type-2 {
    opacity: 0;
  }
  .type-1 {
    font-size: 22px;
    color: #333f4e;
    font-weight: 500;
    letter-spacing: 1px;
  }
  .type-3 {
    .course-card {
      &:last-child {
        margin-right: 0 !important;
      }
    }
  }
}
.no-data {
  padding: 208px 0 302px !important;
}
</style>